import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#030303', color: '#ede8e0', fontFamily: 'Georgia,serif', flexDirection: 'column', gap: 16 }}>
        <h1 style={{ color: '#C4944A', fontSize: 24 }}>Julia Milows</h1>
        <p>Something went wrong. Please reload the page.</p>
        <button onClick={() => location.reload()} style={{ padding: '12px 32px', background: '#C4944A', border: 'none', color: '#030303', cursor: 'pointer', fontWeight: 700, letterSpacing: 2 }}>Reload</button>
      </div>
    );
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
